import script from "./AddCreditmemo.vue?vue&type=script&setup=true&lang=js"
export * from "./AddCreditmemo.vue?vue&type=script&setup=true&lang=js"

import "./AddCreditmemo.vue?vue&type=style&index=0&id=0093876f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0093876f"]])

export default __exports__